import { COLORS } from '@btime/constants'
import { useTranslation } from 'react-i18next'
import React from 'react'

import { HorizontalLine } from '../../../components/shapes/Line'
import { PermissionChecker } from '../../session'
import { TabsContext } from '../../../packages/kiti/components/tabs/TabsContext'
import ControlledModal from '../../../components/modals/ControlledModal'
import Details from './tabs/Details'
import History from './tabs/History'
import ModalHeader from './ModalHeader'
import PlaceAvailabilityLoader from './_load/PlaceAvailabilityLoader'
import Separator from '../../../packages/kiti/components/helpers/Separator'
import TabsContent from '../../../packages/kiti/components/tabs/TabsContent'

const AvailabilityDetailsModal = () => {
  const { t } = useTranslation('availability')

  const tabsOptions = [
    { name: t('tabs.details'), render: () => <Details /> },
    { name: t('tabs.history'), render: () => <History /> }
  ]

  return (
    <PermissionChecker permission="useAvailabilityPanel">
      <PlaceAvailabilityLoader>
        <TabsContext options={tabsOptions}>
          <ModalHeader />

          <HorizontalLine thin lineColor={COLORS.light2} />
          <Separator weight={4} />

          <TabsContent />
        </TabsContext>
      </PlaceAvailabilityLoader>
    </PermissionChecker>
  )
}

const Wrapper = props => (
  <ControlledModal width="60rem" {...props}>
    <AvailabilityDetailsModal {...props} />
  </ControlledModal>
)

export default Wrapper
